export default {
  about: 'About',
  addOns: 'Add-ons',
  agenda: 'Agenda',
  all: 'All',
  browse: 'Browse',
  buyTickets: 'Buy tickets',
  countSelected: '{{count}} selected',
  included: 'Included',
  joining: 'Joining',
  joinWaitlist: 'Join Waitlist',
  menu: 'Menu',
  noDatesAvailable: 'No dates available',
  salesEnded: 'Sales ended',
  schedule: 'Schedule',
  seeMoreDates: 'See more dates',
  soldOut: 'Sold out',
  tickets: 'Tickets',
  viewMore: 'View more',
  viewLess: 'View less',
  location: 'Location',
  time: 'Time',
  at: 'at',
  noTimesAvailableOnThisDateFotThisPartySize:
    'No times available on this date for this party size',
  availableTimes: 'Available times',
  waitlist: 'Waitlist',
  continue: 'Continue',
  ticketsAreNoLongerAvailable: 'Tickets are no longer available.',
  checkOutOutOtherExperiences: 'Check out our other experiences!',
  viewExperiences: 'View experiences',
  from: 'from',
  cancellationPolicy: 'Cancellation policy',
  rsvp: 'RSVP',
  nights: 'nights',
  request: 'Request',
  arrival: 'Arrival',
  departure: 'Departure',
};
